// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  UntilEOL = 1,
  untilCommentClose = 322,
  Program = 2,
  FunctionDefinition = 3,
  FunctionPrototype = 4,
  QualifiedType = 5,
  TypeQualifier = 6,
  StorageQualifier = 7,
  Identifier = 8,
  _const = 9,
  inout = 10,
  _in = 11,
  out = 12,
  centroid = 13,
  patch = 14,
  sample = 15,
  uniform = 16,
  buffer = 17,
  shared = 18,
  coherent = 19,
  volatile = 20,
  restrict = 21,
  readonly = 22,
  writeonly = 23,
  subroutine = 24,
  TypeNameList = 25,
  TypeName = 26,
  LayoutQualifier = 27,
  layout = 28,
  LayoutQualifierId = 29,
  PrivateIdentifier = 30,
  Reserved = 31,
  common = 32,
  partition = 33,
  active = 34,
  asm = 35,
  _class = 36,
  union = 37,
  _enum = 38,
  typedef = 39,
  template = 40,
  _this = 41,
  resource = 42,
  goto = 43,
  inline = 44,
  noinline = 45,
  _public = 46,
  _static = 47,
  extern = 48,
  external = 49,
  _interface = 50,
  long = 51,
  short = 52,
  half = 53,
  fixed = 54,
  unsigned = 55,
  superp = 56,
  input = 57,
  output = 58,
  hvec2 = 59,
  hvec3 = 60,
  hvec4 = 61,
  fvec2 = 62,
  fvec3 = 63,
  fvec4 = 64,
  sampler3DRect = 65,
  filter = 66,
  sizeof = 67,
  cast = 68,
  namespace = 69,
  using = 70,
  Number = 71,
  Parens = 72,
  Assignment = 73,
  MulAssign = 74,
  DivAssign = 75,
  ModAssign = 76,
  AddAssign = 77,
  SubAssign = 78,
  LeftAssign = 79,
  RightAssign = 80,
  AndAssign = 81,
  XorAssign = 82,
  OrAssign = 83,
  Index = 84,
  LeftBracket = 85,
  RightBracket = 86,
  FunctionCall = 87,
  _void = 88,
  float = 89,
  double = 90,
  int = 91,
  uint = 92,
  atomic_uint = 93,
  bool = 94,
  mat2 = 95,
  mat3 = 96,
  mat4 = 97,
  dmat2 = 98,
  dmat3 = 99,
  dmat4 = 100,
  mat2x2 = 101,
  mat2x3 = 102,
  mat2x4 = 103,
  dmat2x2 = 104,
  dmat2x3 = 105,
  dmat2x4 = 106,
  mat3x2 = 107,
  mat3x3 = 108,
  mat3x4 = 109,
  dmat3x2 = 110,
  dmat3x3 = 111,
  dmat3x4 = 112,
  mat4x2 = 113,
  mat4x3 = 114,
  mat4x4 = 115,
  dmat4x2 = 116,
  dmat4x3 = 117,
  dmat4x4 = 118,
  vec2 = 119,
  vec3 = 120,
  vec4 = 121,
  ivec2 = 122,
  ivec3 = 123,
  ivec4 = 124,
  bvec2 = 125,
  bvec3 = 126,
  bvec4 = 127,
  dvec2 = 128,
  dvec3 = 129,
  dvec4 = 130,
  uvec2 = 131,
  uvec3 = 132,
  uvec4 = 133,
  sampler3D = 134,
  samplerCube = 135,
  sampler1DShadow = 136,
  sampler2DShadow = 137,
  samplerCubeShadow = 138,
  sampler1DArray = 139,
  sampler2DArray = 140,
  sampler1DArrayShadow = 141,
  sampler2DArrayShadow = 142,
  samplerCubeArray = 143,
  samplerCubeArrayShadow = 144,
  isampler1D = 145,
  isampler2D = 146,
  isampler3D = 147,
  isamplerCube = 148,
  isampler1DArray = 149,
  isampler2DArray = 150,
  isamplerCubeArray = 151,
  usampler1D = 152,
  usampler2D = 153,
  usampler3D = 154,
  usamplerCube = 155,
  usampler1DArray = 156,
  usampler2DArray = 157,
  usamplerCubeArray = 158,
  sampler2DRect = 159,
  sampler2DRectShadow = 160,
  isampler2DRect = 161,
  usampler2DRect = 162,
  samplerBuffer = 163,
  isamplerBuffer = 164,
  usamplerBuffer = 165,
  sampler2DMS = 166,
  isampler2DMS = 167,
  usampler2DMS = 168,
  sampler2DMSArray = 169,
  isampler2DMSArray = 170,
  usampler2DMSArray = 171,
  image1D = 172,
  iimage1D = 173,
  uimage1D = 174,
  image2D = 175,
  iimage2D = 176,
  uimage2D = 177,
  image3D = 178,
  iimage3D = 179,
  uimage3D = 180,
  image2DRect = 181,
  iimage2DRect = 182,
  uimage2DRect = 183,
  imageCube = 184,
  iimageCube = 185,
  uimageCube = 186,
  imageBuffer = 187,
  iimageBuffer = 188,
  uimageBuffer = 189,
  image1DArray = 190,
  iimage1DArray = 191,
  uimage1DArray = 192,
  image2DArray = 193,
  iimage2DArray = 194,
  uimage2DArray = 195,
  imageCubeArray = 196,
  iimageCubeArray = 197,
  uimageCubeArray = 198,
  image2DMS = 199,
  iimage2DMS = 200,
  uimage2DMS = 201,
  image2DMSArray = 202,
  iimage2DMSArray = 203,
  uimage2DMSArray = 204,
  Field = 205,
  Postfix = 206,
  Inc = 207,
  Dec = 208,
  Unary = 209,
  Add = 210,
  Sub = 211,
  Bang = 212,
  Tilde = 213,
  Binary = 214,
  Mul = 215,
  Div = 216,
  Mod = 217,
  Left = 218,
  Right = 219,
  Lt = 220,
  Lte = 221,
  Gt = 222,
  Gte = 223,
  Eq = 224,
  Neq = 225,
  And = 226,
  Or = 227,
  Xor = 228,
  AndAnd = 229,
  OrOr = 230,
  XorXor = 231,
  Conditional = 232,
  PrecisionQualifier = 233,
  highp = 234,
  medp = 235,
  lowp = 236,
  InterpolationQualifier = 237,
  smooth = 238,
  flat = 239,
  noperspective = 240,
  InvariantQualifier = 241,
  invariant = 242,
  PreciseQualifier = 243,
  precise = 244,
  TypeSpecifier = 245,
  Struct = 246,
  struct = 247,
  StructDeclarationList = 248,
  StructDeclaration = 249,
  StructDeclarationSpecifier = 250,
  ArraySpecifier = 251,
  EmptyBrackets = 252,
  ParameterDeclaration = 253,
  StatementList = 254,
  Statement = 255,
  DeclarationStatement = 256,
  LocalDeclaration = 257,
  VariableDeclaration = 258,
  SingleDeclaration = 259,
  DeclarationSpecifier = 260,
  precision = 261,
  ExpressionStatement = 262,
  SelectionStatement = 263,
  _if = 264,
  _else = 265,
  SwitchStatement = 266,
  _switch = 267,
  CaseLabel = 268,
  _default = 269,
  _case = 270,
  IterationStatement = 271,
  _while = 272,
  Condition = 273,
  _do = 274,
  _for = 275,
  JumpStatement = 276,
  _continue = 277,
  _break = 278,
  _return = 279,
  discard = 280,
  Preprocessor = 281,
  pragma = 282,
  _import = 283,
  ImportDeclarationList = 284,
  ImportDeclaration = 285,
  String = 286,
  _export = 287,
  optional = 288,
  global = 289,
  optimize = 290,
  debug = 291,
  STDGL = 292,
  Directive = 293,
  define = 294,
  undef = 295,
  ifdef = 296,
  ifndef = 297,
  elif = 298,
  endif = 299,
  error = 300,
  extension = 301,
  version = 302,
  line = 303,
  GlobalDeclaration = 304,
  QualifiedStructDeclaration = 305,
  QualifiedDeclaration = 306
